<template>
  <div>
    <div
      v-for="address in addresses"
      :class="{ selected: JSON.stringify(currentAddress) === JSON.stringify(address) }"
      @click="selectAddress(address)"
      class="address privacy"
    >
      <div v-if="address.company">{{ address.company }}</div>
      <div>{{ address.firstname }} {{ address.lastname }}</div>
      <div>{{ address.address1 }} {{ address.street_number }}</div>
      <div>{{ address.zipcode }} {{ address.city }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddressChooser",
  props: {
    initialAddress: {
      type: Object,
      default: () => ({}),
    },
    addresses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentAddress: this.initialAddress,
    };
  },
  methods: {
    selectAddress(address) {
      this.currentAddress = address;

      this.$emit("change", address);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~styles/global";

.address {
  font-size: $font-size-sm;
  display: inline-block;
  position: relative;
  padding: $spacer-2;
  margin-bottom: $spacer-2;
  margin-right: $spacer-2;
  border: $width-border-thin solid $gray-300;
  border-radius: $border-radius-lg;
  cursor: pointer;

  @media (min-width: $screen-sm-min) {
    font-size: $font-size-sm;
  }

  @include hover-states {
    background-color: $gray-200;
  }
}

.address.selected {
  background-color: $gray-300;
}
</style>
